import { render, staticRenderFns } from "./forgot-password.component.vue?vue&type=template&id=5bc0b098&"
import script from "./forgot-password.component.vue?vue&type=script&lang=ts&"
export * from "./forgot-password.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "forgot-password.component.vue"
export default component.exports